import API from './API.js'

export default class Meetings extends API {
  constructor() {
    super('meetings')
  }
}
